const SECTION_TYPES = {
	INITIAL_STATE: 'SECTIONS/INITIAL_STATE',
	GET_ALL: 'SECTIONS/GET_ALL',
	GET_BY_USER: 'SECTIONS/GET_BY_USER',
	SET_ALL: 'SECTIONS/SET_ALL',
	GET_ONE: 'SECTIONS/GET_ONE',
	SET_ONE: 'SECTIONS/SET_ONE',
	CREATE: 'SECTIONS/CREATE',
	UPDATE: 'SECTIONS/UPDATE',
	REMOVE: 'SECTIONS/REMOVE',
	UPDATE_SHOW_RANDOM: 'SECTIONS/UPDATE_SHOW_RANDOM',
	UPDATE_QUESTIONS_EXAM: 'SECTIONS/UPDATE_QUESTIONS_EXAM',
	UPDATE_ORDER: 'SECTIONS/UPDATE_ORDER',
	TRACK: 'SECTIONS/TRACK',
	SET: 'SECTIONS/SET',
};

export default SECTION_TYPES;
